export enum MessageDirectionEnum {
  Server_To_ChargingStation = 'CSMS_2_CS',
  ChargingStation_To_Server = 'CS_2_CSMS',
}
